
  import { Vue, Component, Prop } from "vue-property-decorator";
  import StatusChip from "@/components/icons/StatusChip.vue";
  import EmployeeDataProvider from "@/components/employee/EmployeeDataProvider.vue";
  import RouteParams from "@/entities/RouteParams";
  import EmployeeCardTag from "@/components/employee/EmployeeCardTag.vue";
  import EmployeeTag from "@/components/employee/EmployeeTag.vue";
  import EmployeeCardUserName from "@/components/employee/EmployeeCardUserName.vue";
  import { Contractor, Tag } from "@/generated/graphql";

  @Component({
    components: {
      EmployeeCardUserName,
      EmployeeTag,
      EmployeeCardTag,
      EmployeeDataProvider,
      StatusChip,
    },
  })
  export default class EmployeeCardName extends Vue {
    @Prop({ type: String, required: true }) readonly userUpdatedDate!: string;
    @Prop({ type: String, required: true }) readonly status!: string;
    @Prop({ type: String, required: true }) readonly givenName!: string;
    @Prop({ type: String, required: true }) readonly familyName!: string;
    @Prop({ type: String, default: undefined }) readonly contractorId?: string;
    @Prop({ type: Object, required: true }) readonly employeePageRouteParams!: RouteParams<{ id: string }>;
    @Prop({ type: String, default: undefined }) readonly avatar?: string;
    @Prop({ type: Object, default: undefined }) readonly contractor?: Contractor;

    get tagName(): string {
      return this.contractor?.tag?.name || "";
    }

    get appliedTag(): Tag | undefined {
      return this.contractor?.tag || undefined;
    }
  }
